import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "backgroundsSpritesheets/tablet/48_halloween_pumpkin/48_halloween_pumpkin"
 * Contains 1 texture(s)
 */
export class Tablet48HalloweenPumpkinAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'backgroundsSpritesheets/tablet/48_halloween_pumpkin/48_halloween_pumpkin';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '48_halloween_pumpkin.jpg'
    ] as const;
}
